
/* injects from baggage-loader */

'use strict';

export default class ActionsAcceptInviteController {

	constructor($log, $state, $timeout, Parse, User) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
		this.Parse = Parse;
		this.User = User;

		this.creating_account = false;
		this.signup_error = null;

		this.user = {};

	}

	$onInit() {
		this.user.email = this.invitation.email;

		// Logout any current user
		this.Parse.User.logOut();

	}

	async signup() {

		this.signup_error = null;

		if (!this.user.email) {
			this.signup_error = 'Missing "email"';
			return;
		}
		if (!this.user.password || !this.user.password_verify) {
			this.signup_error = 'Missing "password"';
			return;
		}
		if (this.user.password !== this.user.password_verify) {
			this.signup_error = 'The passwords do not match';
			return;
		}

		this.creating_account = true;

		try {

			// Accept account invitation and create user
			let newUser = await this.Parse.Cloud.run('acceptAccountInvite', {
				user: this.user,
				invitationId: this.invitation.id
			});

			await this.User.authenticate({
				email: this.user.email,
				password: this.user.password
			})

			// Go to dashboard
			this.$state.go('account.dashboard');

		} catch (err) {
			this.creating_account = false;
			this.signup_error = err.toString().replace('ParseError: 141', '');
			this.$timeout()
		}

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/actions/accept-invite/actions.accept-invite.controller.js